import { useI18n } from "../../i18n/useI18n";
import { useBranding } from "../../hooks/useBranding";
import logoUrl from "../../assets/fiket-logo.svg";

/**
 * 부스 잠금 화면. admin 에서 운영 OFF 시 표시.
 * 터치 이벤트 없음 — 다시 켜질 때까지 새로고침으로만 해제.
 */
export function LockView() {
  const { t } = useI18n();
  const { wordmark } = useBranding();
  return (
    <div className="view center">
      <span className="wordmark"><img src={logoUrl} alt={wordmark} draggable={false} /></span>
      <h1 style={{ fontSize: 40, marginTop: 16 }}>{t.lock.title}</h1>
      <p>{t.lock.body}</p>
    </div>
  );
}
